module.exports = __webpack_public_path__ + "static/media/Groupspeaker.85308dc4.svg";